var map = {
	"./cradles/cradle.module.ngfactory": [
		"gwrR",
		0,
		2
	],
	"./patient/patient-worklist.module.ngfactory": [
		"vK1I",
		0,
		6
	],
	"./patient/patient.module.ngfactory": [
		"cnEB",
		0,
		5
	],
	"./sysadmin/sysadmin.module.ngfactory": [
		"UJAv",
		0,
		11
	],
	"./users/users.module.ngfactory": [
		"WKV2",
		12
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "zn8P";
module.exports = webpackAsyncContext;